import { getRequest, postRequest } from '@/utils/request';
import { postRequest as post, getRequest as get } from '@/utils/fetch';
import { EnumList, WorkOrderCategoryType } from '@/type/systemSetting';
import { OSSAssetsType, portTexts } from '@/type/common';
import { DynamicTableType } from '@/type/dynamicTable';
import { DiyFieldItem } from '@/type/dynamicTable';

/**
 * 通用数据
 * 参数：needInfoList=publicSentimentEnum,afterSaleTypeEnum...
 * publicSentimentEnum--舆情情况,
 * afterSaleTypeEnum--售后方式,
 * flowNodeEnum--处理节点
 */
export const getCommonEnumInfo = (needInfoList: string) => {
    return getRequest<EnumList>('/work-order/workOrder/common/info', {
        needInfoList,
    });
};

// 阿里云oss相关接口
export const getOSSPolicy = () => {
    return getRequest<OSSAssetsType>('/work-order/workOrder/oss/policy');
};

// 谷歌 gcs token
export const getGCSPolicy = () => {
    return getRequest<GCSAssetsType>(
        '/work-order/workOrder/gcs/getAccessToken',
    );
};

// 文件上传 - 根据智齿会话ID获取会话文件(视频 / 图片)
export const getUserSessionInfo = (pramas: any) => {
    return postRequest('/css/get/user/session/info', pramas);
};

// 文件上传 - 根据天润会话ID获取会话文件(视频 / 图片)
export const getSessionImgs = (pramas: any) => {
    return get('/work-order/workOrder/im/session/img', pramas);
};

// 根据名称模糊查询商品系列
export const getSeriesByName = (series_name: string) => {
    return postRequest('/series/search', {
        series_name,
    });
};

// 根据系列名查询 系列下的商品
export const getProductBySeriesName = (series_name: string) => {
    return postRequest('/product/search', {
        series_name,
    });
};

// 根据商品短码查询商品配件
export const getAccessoryList = (product_code: string) => {
    return postRequest('/css/aftersale/accessory/list', {
        product_code,
    });
};

// ==================== 上传短信附件

// h5上传获取短信文案
export const getObtainSMScopy = (id: number) => {
    return getRequest(
        `/work-order/workOrder/work/getSmsContent?categoryId=${id}`,
    );
};

// h5发送短信
export const portText = (pramas: portTexts) => {
    return postRequest(`/work-order/workOrder/send/message`, pramas);
};

// CSS售后枚举查询
export const getCommonAftersaleReason = () => {
    return getRequest(`/css/common/aftersaleReason`);
};

// 建单时查询工单分类树
export const getCategoryListWithCreate = (params: {
    isPopLandTab?: number;
}) => {
    return getRequest<WorkOrderCategoryType[]>(
        '/work-order/workOrder/category/listWithCreate',
        params,
    );
};

// 筛选时查询工单分类树
export const getCategoryListWithQuery = (params: { isPopLandTab?: number }) => {
    return getRequest('/work-order/workOrder/category/listWithQuery', params);
};

// 处置日志列表
export const getRecordLogList = (params: any) => {
    return postRequest('/work-order/workOrder/recordLog/list', params);
};

// 保存表格自定义列表字段
export const setDiyList = (pramas: {
    type: number;
    showFields: DiyFieldItem[];
}) => {
    return postRequest('/work-order/workOrder/common/save/diyList', pramas);
};

// 查询自定义列表字段
export const getDiyList = (params: { type: DynamicTableType }) => {
    return getRequest('/work-order/workOrder/common/query/diyList', params);
};

// 根据订单号获取商品列表
export const getGoodsListByOrder = (params) => {
    return getRequest('/css/work/order/goodsList', params);
};

// 根据系列获取商品列表
export const getGoodsListBySeriesName = (series_name: string) => {
    return post('/simple/product/search', { series_name });
};

// 根据隐私加密串请求明文信息
export const getTextByEncryp = (params: {
    type: number;
    sourceNo?: string;
    encryptList: string[];
}) => {
    return post('/work-order/workOrder/common/decrypt', params);
};

// 获取商品属性
export const getAllProductCategory = () => {
    return post('/product/category/search');
};

// 国际化 切换站点 免登录验证
export const changeStation = (params) => {
    return post('/rbac/user/changeStation', params);
};

// URL方式上传
export const ossUrlUpload = (params: {
    dir: string;
    fileName: string;
    url: string;
}) => {
    return post('/work-order/workOrder/oss/urlUpload', params);
};
